import { ApiManager } from "../api/ApiManager"
import {
    SAVE_FEATURE_CONFIG_INFO,
    CLEAR_FEATURE_CONFIG_INFO
} from "./ActionTypes"
import { IFeatureConfigRequest, IFeatureConfigResponse } from "../models/IFeatureConfig";
import { FeatureConfigValues } from "../utils/AppConstants";


export class FeatureConfigInfoActions {

    static fetchFeatureConfigInfo = (dispatch: any, params: IFeatureConfigRequest): Promise<IFeatureConfigResponse> => {
        return new Promise((resolve, reject) => {
            ApiManager.getOllivanderServiceApis().fetchFeatueConfigInfo(params)
                .then((response: IFeatureConfigResponse) => {
                    dispatch(FeatureConfigInfoActions.setFeatureConfigInfo(response));
                    resolve(response);
                })
                .catch(() => {
                    const configResponse: IFeatureConfigResponse = { configName: params.configName, configValue: FeatureConfigValues.FALSE }
                    dispatch(FeatureConfigInfoActions.setFeatureConfigInfo(configResponse));
                    resolve(configResponse);
                })
        })
    }

    static setFeatureConfigInfo = (response: IFeatureConfigResponse) => {
        return {
            type: SAVE_FEATURE_CONFIG_INFO,
            payload: response
        };
    }

    static clearFeatureConfigInfos = () => {
        return { type: CLEAR_FEATURE_CONFIG_INFO };
    }

    static getSectionAllowed = async (doctorType: string, sectionKey: string): Promise<any> => {
        return ApiManager.getEHRApis().getSectionAllowed(doctorType, sectionKey)
    }
}


